import React from 'react';
import { Table, Icon } from 'semantic-ui-react';
import { shortenMonth } from '../helpers/TableUtils.jsx';
import { hasResults } from '../helpers/EventUtils';

const styles = {
  dateLabel: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    padding: '6px 12px',
    backgroundColor: '#f0f8f0',
    borderRadius: '6px',
    color: '#569556',
    fontWeight: '500',
    fontSize: '0.9rem',
  },
  link: {
    color: '#569556',
    textDecoration: 'none',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '5px',
  },
  cell: {
    verticalAlign: 'middle',
  },
};

const TableRow = ({ bridgeEvent }) => {
  const renderTable = () => {
    return (
      <Table.Row>
        <Table.Cell style={styles.cell}>
          <span style={styles.dateLabel}>
            <Icon name="calendar" style={{ margin: 0 }} />
            {bridgeEvent.event_day} {shortenMonth(bridgeEvent.event_month)} {bridgeEvent.event_year}
          </span>
        </Table.Cell>
        <Table.Cell style={styles.cell}>{bridgeEvent.event_location}</Table.Cell>
        <Table.Cell style={styles.cell}>{bridgeEvent.event_club}</Table.Cell>
        <Table.Cell style={styles.cell}>
          {bridgeEvent.event_results !== 'available after competition' && (
            <a
              href={bridgeEvent.event_results}
              target="_blank"
              rel="noopener noreferrer"
              style={styles.link}
            >
              <Icon name="file alternate" /> View Results
            </a>
          )}
        </Table.Cell>
        <Table.Cell style={styles.cell}>
          {bridgeEvent.event_hands !== 'available after competition' && (
            <a
              href={bridgeEvent.event_hands}
              target="_blank"
              rel="noopener noreferrer"
              style={styles.link}
            >
              <Icon name="clone" /> View Hands
            </a>
          )}
        </Table.Cell>
      </Table.Row>
    );
  };

  return hasResults(bridgeEvent) ? renderTable() : null;
};

export default TableRow;
